import { Link } from 'react-router-dom';
import { MessageCircle, Phone, Stethoscope } from 'lucide-react';
import { useCompareStore } from '@/stores/compareStore';

/**
 * Phones only (2026-10-14, owner-approved): one fixed bar at the bottom with
 * the three ways to reach Benayahu — call, WhatsApp, free consultation —
 * instead of scattered floating circles. The weekly report (automation/
 * weekly_sources.py) counted 0 WhatsApp clicks a week before it. Links carry
 * data-track-from="mobile-bar" so public/contact-clicks.js counts them.
 * Steps aside while the catalog's compare bar holds the bottom of the screen.
 */
const WA = `https://wa.me/972546672863?text=${encodeURIComponent('שלום בניהו, יש לי שאלה:')}`;

export default function MobileActionBar() {
  const comparing = useCompareStore((s) => s.ids.length) > 0;
  if (comparing) return null;
  const item =
    'flex flex-1 flex-col items-center justify-center gap-0.5 rounded-xl py-2 text-[13px] font-bold transition-transform duration-150 active:scale-[0.96]';
  return (
    <nav
      aria-label="יצירת קשר מהירה"
      className="md:hidden fixed inset-x-0 bottom-0 z-50 border-t border-[var(--cin-line)] bg-white/95 px-3 pt-2 pb-[calc(8px+env(safe-area-inset-bottom,0px))] backdrop-blur-md shadow-[0_-8px_24px_-12px_rgba(15,23,41,0.25)]"
    >
      <div className="flex items-stretch gap-2" dir="rtl">
        <a href="tel:+972546672863" data-track-from="mobile-bar" className={`${item} text-[var(--cin-ink)] bg-[var(--cin-paper-soft)]`}>
          <Phone className="h-5 w-5" aria-hidden="true" />
          התקשרו
        </a>
        <a
          href={WA}
          target="_blank"
          rel="noopener noreferrer"
          data-track-from="mobile-bar"
          className={`${item} bg-[#25D366] text-[#06281a]`}
        >
          <MessageCircle className="h-5 w-5" aria-hidden="true" />
          וואטסאפ
        </a>
        <Link to="/diagnose" className={`${item} text-[var(--cin-blue)] bg-[var(--cin-blue)]/10`}>
          <Stethoscope className="h-5 w-5" aria-hidden="true" />
          ייעוץ חינם
        </Link>
      </div>
    </nav>
  );
}
